import { render, staticRenderFns } from "./table_lite.vue?vue&type=template&id=8487ad72"
import script from "./table_lite.vue?vue&type=script&lang=js"
export * from "./table_lite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports